import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import '../garage.css';
import { UserContext } from '../userContext';
import { Part, isUnit, Frame, ACData } from '../interfaces';
import BuildCard from '../partials/build_card';
import { H1, H5, H6, Button, Card, CardList, Dialog, DialogBody, DialogFooter, Section, SectionCard, OverlayToaster, Intent, H2, Tag, Popover, Classes } from '@blueprintjs/core';
import { LoaderFunctionArgs, useLoaderData } from 'react-router-dom';

async function loader({ params }: LoaderFunctionArgs) {
  const newACData = {
    id: undefined,
    name: undefined,
    platform: undefined,
    shareKey: undefined,
    frame: {
      rArmUnit: undefined,
      lArmUnit: undefined,
      rBackUnit: undefined,
      lBackUnit: undefined,
      head: undefined,
      core: undefined,
      arms: undefined,
      legs: undefined,
      booster: undefined,
      fcs: undefined,
      generator: undefined,
      expansion: undefined,
    }
  };

  if (Object.keys(params).length === 0) {
    return newACData;
  }

  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/build/${params.id}`);
    return response.data['items'][0];
  } catch (error) {
    console.log(error)
    return newACData;
  }
}


function Garage() {
  const [acData, setACData] = useState<ACData>(useLoaderData() as ACData);
  const [selectedPartType, setSelectedPartType] = useState<null | string>(null);
  const user = useContext(UserContext);

  const showParts = (partType: null | string) => {
    setSelectedPartType(partType)
  }

  const setPart = (type: string, part: null | Part) => {
    switch (type) {
      case "R-ARM UNIT":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ rArmUnit: part } } } }; }); break;
      case "L-ARM UNIT":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ lArmUnit: part } } } }; }); break;
      case "R-BACK UNIT":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ rBackUnit: part } } } }; }); break;
      case "L-BACK UNIT":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ lBackUnit: part } } } }; }); break;
      case "HEAD":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ head: part } } } }; }); break;
      case "CORE":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ core: part } } } }; }); break;
      case "ARMS":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ arms: part } } } }; }); break;
      case "LEGS":
        setACData(acData => {
          if (((part as any).type === "Tank") && acData.frame.booster?.id) {
            return { ...acData, ...{ frame: { ...acData.frame, ...{ legs: part, booster: null } } } };
          } else {
            return { ...acData, ...{ frame: { ...acData.frame, ...{ legs: part } } } };
          }
        });
        break;
      case "BOOSTER":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ booster: part } } } }; }); break;
      case "FCS":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ fcs: part } } } }; }); break;
      case "GENERATOR":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ generator: part } } } }; }); break;
      case "EXPANSION":
        setACData(acData => { return { ...acData, ...{ frame: { ...acData.frame, ...{ expansion: part } } } }; }); break;
    }
  }

  return (
    <div>
      <div style={{ padding: "50px" }}>
        <div className="left" style={{ display: "flex", flexDirection: "column", width: "250px" }}>
          {selectedPartType === null &&
            <div>
              <Assembly frame={acData.frame} showParts={showParts} />
            </div>
          }
          {selectedPartType &&
            <PartList type={selectedPartType} selectedId={((type) => {
              switch (type) {
                case "R-ARM UNIT":
                  return acData.frame.rArmUnit?.id;
                case "L-ARM UNIT":
                  return acData.frame.lArmUnit?.id;
                case "R-BACK UNIT":
                  return acData.frame.rBackUnit?.id;
                case "L-BACK UNIT":
                  return acData.frame.lBackUnit?.id;
                case "HEAD":
                  return acData.frame.head?.id;
                case "CORE":
                  return acData.frame.core?.id;
                case "ARMS":
                  return acData.frame.arms?.id;
                case "LEGS":
                  return acData.frame.legs?.id;
                case "BOOSTER":
                  return acData.frame.booster?.id;
                case "FCS":
                  return acData.frame.fcs?.id;
                case "GENERATOR":
                  return acData.frame.generator?.id;
                case "EXPANSION":
                  return acData.frame.expansion?.id;
              }
            })(selectedPartType)} showParts={showParts} setPart={setPart} />
          }
          {user &&
            <ButtonWithSubmitDialog acData={acData} setACData={setACData} />
          }
        </div>
        <div className="centre">
          <div className="part-specs"></div>
        </div>
        <div className="right">
          <div className="ap-specs"></div>
        </div>
      </div>

    </div>


  );
}

interface SelectedPartCardProps {
  type: string
  name: undefined | string
  showParts: (partType: string) => void
}

function SelectedPartCard({ name, type, showParts }: SelectedPartCardProps) {
  return (
    <Card onClick={() => showParts(type)} style={{ display: "block" }} interactive>
      <H6 style={{ textAlign: "right" }}>{type}</H6>
      <H5>{name ? name : "None"}</H5>
    </Card>
  );
}

interface AssemblyProps {
  frame: Frame
  showParts: (partType: string) => void
}

function Assembly({ frame, showParts }: AssemblyProps) {
  return (
    <div className="assembly">
      <H1>ASSEMBLY</H1>
      <Section title="UNIT" compact>
        <SectionCard>
          <CardList compact>
            <SelectedPartCard type="R-ARM UNIT" name={frame.rArmUnit?.name} showParts={showParts} />
            <SelectedPartCard type="L-ARM UNIT" name={frame.lArmUnit?.name} showParts={showParts} />
            <SelectedPartCard type="R-BACK UNIT" name={frame.rBackUnit?.name} showParts={showParts} />
            <SelectedPartCard type="L-BACK UNIT" name={frame.lBackUnit?.name} showParts={showParts} />
          </CardList>
        </SectionCard>
      </Section>
      <Section title="FRAME" compact>
        <SectionCard>
          <CardList compact>
            <SelectedPartCard type="HEAD" name={frame.head?.name} showParts={showParts} />
            <SelectedPartCard type="CORE" name={frame.core?.name} showParts={showParts} />
            <SelectedPartCard type="ARMS" name={frame.arms?.name} showParts={showParts} />
            <SelectedPartCard type="LEGS" name={frame.legs?.name} showParts={showParts} />
          </CardList>
        </SectionCard>
      </Section>
      <Section title="INNER" compact>
        <SectionCard>
          <CardList compact>
            <SelectedPartCard type="BOOSTER" name={frame.booster?.name} showParts={showParts} />
            <SelectedPartCard type="FCS" name={frame.fcs?.name} showParts={showParts} />
            <SelectedPartCard type="GENERATOR" name={frame.generator?.name} showParts={showParts} />
          </CardList>
        </SectionCard>
      </Section>
      <Section title="EXPANSION" compact>
        <SectionCard>
          <CardList compact>
            <SelectedPartCard type="EXPANSION" name={frame.expansion?.name} showParts={showParts} />
          </CardList>
        </SectionCard>
      </Section>
    </div>
  );
}

interface PartListProps {
  type: string
  selectedId: number | undefined
  showParts: (partType: null | string) => void
  setPart: (type: string, part: null | Part) => void
}
function PartList({ type, selectedId, showParts, setPart }: PartListProps) {
  const [partList, setPartList] = useState([]);
  const [base_type, side, back] = function (): [string, null | string, null | boolean] {
    switch (type) {
      case "R-ARM UNIT":
        return ["unit", "R", false];
      case "L-ARM UNIT":
        return ["unit", "L", false];
      case "R-BACK UNIT":
        return ["unit", "R", true];
      case "L-BACK UNIT":
        return ["unit", "L", true];
      default:
        return [type.toLowerCase(), null, null];
    }
  }()

  useEffect(() => {
    const url = new URL(`${process.env.REACT_APP_API_BASE_URL}/api/${base_type}`)
    if (base_type === "unit") {
      url.searchParams.set("position", back ? "back" : "arm");
      url.searchParams.set("side", side!);
    }
    axios.get(url.toString())
      .then((response) => {
        setPartList((partList) => {
          const items = response.data['items']
          return items ? items : partList
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }, [base_type, back, side])

  return (
    <div>
      <div style={{ display: "flex" }}>
        <Button onClick={() => showParts(null)} icon="caret-left" text="Back" minimal />
        <H2>{type}</H2>
      </div>
      <div style={{ overflowX: "visible", overflowY: "auto", height: "80vh", width: "267px" }}>
        <div style={{ width: "250px" }}>
          {["R-ARM UNIT", "L-ARM UNIT", "R-BACK UNIT", "L-BACK UNIT", "BOOSTER"].includes(type) &&
            <Card className={`${!selectedId && "selected"}`} interactive onClick={() => setPart(type, null)}>
              <h5>None</h5>
            </Card>
          }
          {partList.map((e, i) => {
            let part: any;

            part = {
              id: e['id'],
              name: e['name'],
            }

            switch (base_type) {
              case 'unit':
                part.class = e['class']
                part.attackType = e['attackType']
                part.weaponType = e['weaponType']
                break;
              case 'legs':
                part.type = e['type']
                break;
            }

            return (
              <Card key={i} className={`${part.id === selectedId && "selected"}`} onClick={() => setPart(type, part)} style={{ padding: "0" }} interactive>
                {base_type !== "expansion" &&
                  <img src={`${process.env.REACT_APP_API_BASE_URL}/assets/images/${base_type.toLowerCase()}/${encodeURIComponent(part.name.replaceAll(/[:/]/g, '_'))}.png`} alt={part.name} className="card-img-top" style={{ width: "250px" }} />
                }
                <div style={{ padding: "20px" }}>
                  <H5>{part.name}</H5>
                  {base_type === "legs" &&
                    <>
                      <H6>{part.type}</H6>
                    </>
                  }
                  {isUnit(part) &&
                    <>
                      <H6>{part.class}</H6>
                      <>
                        <Tag>{part.attackType}</Tag>
                        <Tag>{part.weaponType}</Tag>
                      </>
                    </>
                  }
                </div>

              </Card>
            );
          })
          }
        </div>
      </div>
    </div>
  );
}

interface SubmitModalProps {
  acData: ACData
  setACData: (acData: ACData | ((acData: ACData) => ACData)) => void
}

function ButtonWithSubmitDialog({ acData, setACData }: SubmitModalProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleClose = useCallback(() => setIsOpen(false), [])
  const toasterRef = useRef<OverlayToaster>(null);

  useEffect(() => {
    if (acData.platform === undefined) {
      setACData((acData => { return { ...acData, ...{ platform: 0 } } }))
    }
  }, [setACData, acData.platform])

  return (
    <>
      <Button text="Submit"
        onClick={useCallback(() => {
          const validationErrors = [
            { part: acData.frame.head, name: "Head" },
            { part: acData.frame.arms, name: "Core" },
            { part: acData.frame.arms, name: "Arms" },
            { part: acData.frame.legs, name: "Legs" },
            { part: acData.frame.fcs, name: "FCS" },
            { part: acData.frame.generator, name: "Generator" },
          ].map(e => {
            if (!e.part) {
              toasterRef.current?.show({
                intent: Intent.DANGER,
                icon: "warning-sign",
                message: `${e.name} cannot be empty`,
              });
              return true
            }
            return false
          }).filter(e => e);
          if (validationErrors.length > 0) { return; }

          setIsOpen(isOpen => !isOpen)
        }, [acData])} />
      <Dialog isOpen={isOpen} onClose={handleClose}>
        <DialogBody>
          <BuildCard acData={acData} edit setACData={setACData} />
        </DialogBody>
        <DialogFooter actions={
          <>
            <Button onClick={handleClose} text="Cancel" />
            {acData.id &&
              <Popover
                content={<div style={{ padding: "10px" }}>
                  <H5>Confirm Override</H5>
                  <p>Are you sure you want to override this build?</p>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button className={Classes.POPOVER_DISMISS} text="Cancel" />
                    <Button
                      className={Classes.POPOVER_DISMISS}
                      intent={Intent.PRIMARY}
                      text="Confirm"
                      onClick={() => {
                        axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/build/${acData.id}`, acData)
                          .then(response => {
                            if (response.status === 200) {
                              toasterRef.current?.show({
                                intent: Intent.SUCCESS,
                                icon: "tick",
                                message: `Build Updated`,
                              });
                              handleClose();
                            }
                          })
                          .catch(error => {
                            const status = error.response.status;

                            toasterRef.current?.show({
                              intent: Intent.DANGER,
                              icon: "warning-sign",
                              message: `Error ${status}: ${status === 500 ? "Internal Server Error" : JSON.stringify(error.response.data)}`,
                            })
                          })
                      }} />
                  </div>
                </div>}>
                <Button
                  text="Save" />
              </Popover>

            }
            <Button
              intent="primary"
              text="Save As New"
              onClick={() => {
                if (acData.name === undefined || acData.name === "") {
                  toasterRef.current?.show({
                    intent: Intent.DANGER,
                    icon: "warning-sign",
                    message: "Please provide a name for your build",
                  });
                  return
                }
                console.log(acData.platform)
                console.log(acData.shareKey);
                if (acData.shareKey !== undefined && acData.shareKey !== "" && acData.platform === 0) {
                  toasterRef.current?.show({
                    intent: Intent.DANGER,
                    icon: "warning-sign",
                    message: "Share keys are platform specific: Please provide a platform",
                  });
                  return
                }

                axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/build`, acData)
                  .then((response) => {
                    if (response.status === 200) {
                      toasterRef.current?.show({
                        intent: Intent.SUCCESS,
                        icon: "tick",
                        message: "Build submitted!",
                      });
                      handleClose();
                    }
                  })
                  .catch(error => {
                    const status = error.response.status;

                    toasterRef.current?.show({
                      intent: Intent.DANGER,
                      icon: "warning-sign",
                      message: `Error ${status}: ${status === 500 ? "Internal Server Error" : JSON.stringify(error.response.data)}`,
                    });
                  })
              }} />
          </>
        } />
      </Dialog>
      <OverlayToaster ref={toasterRef} />
    </>
  );
}

export default Garage;
export { loader };
